import { defaultInputs } from './constants'

export const declarationsPenaltyValidate = (data: any) => {
  const fields = defaultInputs()

  const getValue = (key: string) => {
    if (data[key] !== undefined) return data[key]
    else return ''
  }

  const anyPrepaymentPenalty = getValue('anyPrepaymentPenalty')
  const otherPrepaymentPenalty = getValue('otherPrepaymentPenalty')
  const defaultInterest = getValue('defaultInterest')

  fields.otherPrepaymentPenaltyOption.disabled = !otherPrepaymentPenalty
  ;[
    'anyPrepaymentPenaltyOption1',
    'anyPrepaymentPenaltyOption2',
    'anyPrepaymentPenaltyOption3',
    'anyPrepaymentPenaltyOption4',
  ].forEach((key) => {
    fields[key].disabled = !anyPrepaymentPenalty
  })
  ;[
    'defaultAfter',
    'defaultAfterUnit',
    'defaultEffectiveUntil',
    'defaultRateMethod',
    'defaultRateValue',
    'distributeToLendersDefaultInterest',
    'distributeToOrigVendorDefaultInterest',
    'distributeToCompanyDefaultInterest',
    'defaultRateHistory',
  ].forEach((key) => {
    fields[key].disabled = !defaultInterest
  })
  ;[
    'prepaymentPenaltyExpires',
    'distributeToLendersPrepayment',
    'distributeToOrigVendorPrepayment',
    'distributeToCompanyPrepayment',
  ].forEach((key) => {
    fields[key].disabled = !anyPrepaymentPenalty && !otherPrepaymentPenalty
  })

  return fields
}
